import React, { useEffect, useState } from "react";
import "./../../css/table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTrash } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "jalali-moment";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";

const UserTable = () => {
  const [posts, setPosts] = useState();
  const [filterPosts, setFilterPosts] = useState();
  const [role, setRole] = useState();
  const [fromMyDate, setFromMyDate] = useState();
  const [toMyDate, setToMyDate] = useState();
  const [isFilter, setIsFilter] = useState(false);
  const [postsLength, setPostsLength] = useState(null);
  const [filteredLength, setFilteredLength] = useState(null);
  const [offset, setOffset] = useState(0);
  const [perPage] = useState(100);
  const [pageCount, setPageCount] = useState();
  const [paginateData, setPaginateData] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [filOffset, setFilOffset] = useState(0);
  const [filPerPage] = useState(100);
  const [filPageCount, setFilPageCount] = useState();
  const [filPaginateData, setFilPaginateData] = useState();
  const [filCurrentPage, setFilCurrentPage] = useState(0);

  useEffect(() => {
    axios
      .get("https://arianaapp.arianaapply.com/panel/show-all-user")
      .then((response) => {
        console.log(response);

        const data = response.data;
        const slice = data.slice(
          offset,
          offset + perPage
        );
  
        setPageCount(Math.ceil(data.length / perPage));
        setPaginateData(slice);
        setPosts(response.data);
        setPostsLength(response.data.length);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          title: "دوباره امتحان کنید",
          icon: "error",
        });
      });
  }, []);
  useEffect(()=>{
    loadMoreData();
  }, [currentPage, offset])

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * perPage;
        setCurrentPage(selectedPage);
        setOffset(offset);
        loadMoreData();
  };

  const loadMoreData = () => {
    const data = posts;
    const slice = data?.slice(
      offset,
      offset + perPage
    );
      setPageCount(Math.ceil(data?.length / perPage));
      setPaginateData(slice);
  }

  const fromHandleChange = (value) => {
    setFromMyDate(value);
  };

  const toHandleChange = (value) => {
    setToMyDate(value);
  };

  const filterByTime = () => {
    axios
      .post("https://arianaapp.arianaapply.com/panel/report/number-users", {
        startTime: moment(new Date(fromMyDate), "yyyy-mm-dd")
          .locale("en")
          .format("YYYY-MM-DD"),
        endTime: moment(new Date(toMyDate), "yyyy-mm-dd")
          .locale("en")
          .format("YYYY-MM-DD"),
      })
      .then((res) => {
        console.log("res", res);
        
        const data = res.data.data[0];
        const slice = data?.slice(
          filOffset,
          filOffset + filPerPage
        );
  
        setFilPageCount(Math.ceil(data?.length / filPerPage));
        setFilPaginateData(slice);
      
        setIsFilter(true);
        setFilterPosts(res.data.data[0]);
        setFilteredLength(res.data.data[0].length);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(()=>{
    filLoadMoreData();
  }, [filCurrentPage, filOffset])

  const filHandlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * filPerPage;
        setFilCurrentPage(selectedPage);
        setFilOffset(offset);
        filLoadMoreData();
  };

  const filLoadMoreData = () => {
    const data = filterPosts;
    const slice = data?.slice(
      filOffset,
      filOffset + filPerPage
    );
      setFilPageCount(Math.ceil(data?.length / filPerPage));
      setFilPaginateData(slice);
  }


  const changeRole = (phone) => {
    console.log('role', role);
    axios
      .post(`https://arianaapp.arianaapply.com/panel/change-role`, {
        phone: phone,
        role
      })
      .then((res) => {
        window.location.reload(false);
      });
  };

  return (
    <div className="index">
      {posts?.length > 0 ? (
        <div className="table">
          <div className="time-filter">
            <h4>فیلتر بر اساس زمان:</h4>
            <div className="time-filter-inputs">
              <div style={{ direction: "rtl" }}>
                <label>از تاریخ:</label>
                <DatePicker
                  value={fromMyDate}
                  onChange={fromHandleChange}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-center"
                />
              </div>
              <div>
                <label>تا تاریخ:</label>
                <DatePicker
                  value={toMyDate}
                  onChange={toHandleChange}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-center"
                />
              </div>
            </div>
            <button
              className="success filter-date-btn"
              onClick={() => filterByTime()}
            >
              فیلتر
            </button>
            {isFilter && (
              <button
                className="danger filter-date-btn"
                onClick={()=> setIsFilter(false)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            )}
          </div>
          <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                margin: "1rem 0",
                fontSize: '20px'
              }}
            >
              <span>تعداد: {!isFilter ? postsLength : filteredLength}</span>
              </div>
          <table>
            <thead>
              <tr>
                <td>#</td>
                <td>نام</td>
                <td>شماره تماس</td>
                <td>نقش</td>
                <td>تغییر نقش</td>
                <td>پلتفرم</td>
                <td>تاریخ ثبت نام</td>
              </tr>
            </thead>
            <tbody>
              {
                !isFilter ?
              paginateData?.map((item, i) => (
                <tr key={item._id}>
                  <td>{i}</td>
                  <td>{item.name}</td>
                  <td>{item.phone}</td>
                  <td>
                    {item.role === "user"
                      ? "کاربر"
                      : item.role === "client"
                      ? "مشتری"
                      : item.role === "admin"
                      ? "ادمین"
                      : item.role === "admissioner"
                      ? "ادمیشنر"
                      : item.role === "client_admission"
                      ? "کلاینت ادمیشن"
                      : null}
                  </td>
                  <td className="role-style">
                    <select value={role} onChange={(e) => setRole(e.target.value)} name="role">
                      <option value="">انتخاب کنید</option>
                      <option value="user">کاربر</option>
                      <option value="client">مشتری</option>
                      <option value="admin">ادمین</option>
                      <option value="admissioner"> ادمیشنر</option>
                      <option value="client_admission">کلاینت ادمیشن</option>
                    </select>
                    <button
                      className="role-btn"
                      onClick={() => changeRole(item.phone)}
                    >
                      <FontAwesomeIcon color="#6366f1" icon={faCheck} />
                    </button>
                  </td>
                  <td>{item.type_App}</td>
                  <td>
                    {moment(item.created_at, "YYYY/MM/DD")
                      .locale("fa")
                      .format("YYYY/MM/DD")}
                  </td>
                </tr>
              )):
              filPaginateData?.map((item, i) => (
                <tr key={item._id}>
                  <td>{i}</td>
                  <td>{item.name}</td>
                  <td>{item.phone}</td>
                  <td>
                    {item.role === "user"
                      ? "کاربر"
                      : item.role === "client"
                      ? "مشتری"
                      : item.role === "admin"
                      ? "ادمین"
                      : item.role === "admissioner"
                      ? "ادمیشنر"
                      : item.role === "client_admission"
                      ? "کلاینت ادمیشن"
                      : null}
                  </td>
                  <td className="role-style">
                    <select value={role} onChange={(e) => setRole(e.target.value)} name="role">
                      <option value="">انتخاب کنید</option>
                      <option value="user">کاربر</option>
                      <option value="client">مشتری</option>
                      <option value="admin">ادمین</option>
                      <option value="admissioner"> ادمیشنر</option>
                      <option value="client_admission">کلاینت ادمیشن</option>
                    </select>
                    <button
                      className="role-btn"
                      onClick={() => changeRole(item.phone)}
                    >
                      <FontAwesomeIcon color="#6366f1" icon={faCheck} />
                    </button>
                  </td>
                  <td>{item.type_App}</td>
                  <td>
                    {moment(item.created_at, "YYYY/MM/DD")
                      .locale("fa")
                      .format("YYYY/MM/DD")}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
          {
            !isFilter ?
            <ReactPaginate
            previousLabel={"قبلی"}
            nextLabel={"بعدی"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={6}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          /> :
          <ReactPaginate
          previousLabel={"قبلی"}
          nextLabel={"بعدی"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={filPageCount}
          marginPagesDisplayed={1}
          pageRangeDisplayed={6}
          onPageChange={filHandlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
          }

        </div>
      ) : (
        <Spinner animation="border" variant="primary" />
      )}
    </div>
  );
};

export default UserTable;
